import { MenuItem, MenuItems } from "../../../../common/AppSidebar/types";

export const filteredItemsByFileType = (
  extensions: string[],
  items: MenuItems,
): MenuItems => {
  return items
    .map((item) => {
      if (item.children && item.children.length > 0) {
        const filteredChildren = filteredItemsByFileType(
          extensions,
          item.children,
        );
        if (filteredChildren.length > 0) {
          return { ...item, children: filteredChildren };
        } else {
          return null;
        }
      } else if (extensions.some((ext) => item.name.endsWith(`.${ext}`))) {
        return item;
      }
      return null;
    })
    .filter((item): item is MenuItem => item !== null);
};
